import { render, staticRenderFns } from "./BaseEntity.vue?vue&type=template&id=390c03c2&"
import script from "./BaseEntity.vue?vue&type=script&lang=ts&"
export * from "./BaseEntity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports